'use strict'

const DEFAULT_PREFIX = 'ls-cache'
const defaultConfig = { keyPrefix: null, ttl: 86400000000 }

class LocalStorage {
  constructor(config) {
    this.config = config
      ? Object.assign({}, defaultConfig, config)
      : defaultConfig
    this.getItem = this.getItem.bind(this)
    this.setItem = this.setItem.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.clear = this.clear.bind(this)
  }

  configure(config) {
    this.config = config
      ? Object.assign({}, defaultConfig, config)
      : defaultConfig
  }

  getItem(key) {
    const storage = window.localStorage
    const fullKey = this._fullKey(key)
    const text = storage.getItem(fullKey)
    if (text) {
      if (!this._isExpired(text)) {
        return JSON.parse(text).data
      } else {
        this.removeItem(key)
      }
    }

    return null
  }

  setItem(key, data) {
    const storage = window.localStorage
    const fullKey = this._fullKey(key)
    const object = Object.assign(
      {},
      {
        data,
        key: fullKey,
        expires: this._getCurrentTime() + this.config.ttl
      }
    )

    storage.setItem(fullKey, JSON.stringify(object))
  }

  removeItem(key) {
    const storage = window.localStorage
    const fullKey = this._fullKey(key)
    storage.removeItem(fullKey)
  }

  clear() {
    let keys = []
    const storage = window.localStorage
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i)
      if (key.includes(this.config.keyPrefix)) {
        keys.push(key)
      }
    }

    keys.forEach(key => {
      storage.removeItem(key)
    })
  }

  _fullKey(key) {
    if (this.config.keyPrefix) {
      return `${DEFAULT_PREFIX}-${this.config.keyPrefix}-${key}`
    }

    return `${DEFAULT_PREFIX}-${key}`
  }

  _isExpired(text) {
    const item = JSON.parse(text)
    return this._getCurrentTime() >= item.expires
  }

  _getCurrentTime() {
    return new Date().getTime()
  }
}

const instance = new LocalStorage()
export default instance
